<template>
    <div class="MyActivity padding-20 bgc box-shadow">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'MyActivity',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.MyActivity {
}
</style>
